<div class="login-body">
    <p-toast position="top-center"></p-toast>
    <div class="login-panel">
      <div class="grid" [formGroup]="form">
        <div class="col-12">
          <img src="assets/layout/images/logo-login.png" />
          <h1>Registrierung</h1>
          <h2>{{app.appName}}</h2>
        </div>
        <div class="col-12">
          <input style="width:100%" type="text" autocomplete="off" class="p-inputtext ui-corner-all p-component"
            placeholder="Benutzername" formControlName="userName">
        </div>
        <div class="col-12">
          <input style="width:100%" type="password" autocomplete="off" class="p-inputtext p-corner-all p-component"
            placeholder="Passwort" formControlName="password">
        </div>
        <div class="col-12">
            <input style="width:100%" type="password" autocomplete="off" class="p-inputtext p-corner-all p-component"
              placeholder="Passwort wiederholen" formControlName="passwordRepeat">
          </div>
          <div class="col-12">
          <p-button styleClass="width100p" icon="fas fa-sign-in" label="Registrieren" (onClick)="send()">
          </p-button>
          <a [routerLink]="['/base', 'login']">
            <p-button styleClass="width100p" icon="fas fa-lock" label="Abbrechen" (onClick)="cancel()">
            </p-button>
          </a>
          <div *ngIf="running">
            <div>Registrierung läuft ...</div>
            <p-progressSpinner></p-progressSpinner>

        </div>
        <p-message *ngIf="!running && done" [severity]="resultType" [text]="resultMessage" styleClass="mr-2"></p-message>
      </div>
    </div>
  </div>
